import { Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./NavItem.css";
import { ReactSVG } from "react-svg";
import DownArrow from '../../assets/icons/DownArrow.svg';
import UpArrow from '../../assets/icons/UpArrow.svg';

export default function NavItem(props) {
    // console.log("navItem props", props);
    let location = useLocation();
    let navigate = useNavigate();

    return (
        <>
            {props.menuType === "parent" && (
                <Nav.Item
                    className={`${props.menu} `}
                    // className={`${props.menu} ${location.pathname === props.path ? "active" : "inactive"}`}

                    onClick={() => {
                        if (props.setOpen) {
                            props.setOpen((prevState) => ({
                                ...Object.keys(prevState).forEach(v => prevState[v] = false),
                                // ...prevState,
                                [props.menu]: props.open[props.menu] ? false : true,
                            }));
                        }
                        if (props.path) {
                            navigate(props.path);
                        }
                        props.setSidebar("open");
                        if (props.onClick) {
                            props.onClick();
                        }
                    }}
                >
                    <Nav.Link
                        as={Link}
                        to={props.path}
                        eventKey={props.menu}
                        bsPrefix={`nav-list-item ${props.menuType} ${location.pathname === props.path ? "active" : "inactive"}`}
                    >
                        {props.menuType === "parent" && (
                            <ReactSVG className="sidebar-icon parent" src={props.icon}></ReactSVG>
                        )}
                        <span className="menu-name">{props.menu}</span>
                    </Nav.Link>

                    {props.ariaControls && (
                        <>
                            {!props.open[props.menu] && (
                                <ReactSVG
                                    src={DownArrow}
                                    className="menu-arrow"
                                    onClick={() => {
                                        props.setOpen((prevState) => ({
                                            ...prevState,
                                            [props.menu]: true,
                                        }));
                                    }}
                                    aria-controls={props.ariaControls}
                                />
                            )}
                            {props.open[props.menu] && (
                                <ReactSVG
                                    src={UpArrow}
                                    className="menu-arrow"
                                    onClick={() => {
                                        props.setOpen((prevState) => ({
                                            ...prevState,
                                            [props.menu]: false,
                                        }));
                                    }}
                                    aria-controls={props.ariaControls}
                                />
                            )}
                        </>
                    )}
                </Nav.Item>
            )}
            {props.menuType === "menu" && (
    (() => {
        const navItem = (
            <Nav.Item
                className={`${location.pathname === props.path ? "active" : "inactive"}`}
                onClick={() => {
                    navigate(props.path);
                    if (window.innerWidth < 768) {
                        props.setSidebar("closed");
                    }
                }}
            >
                <Nav.Link
                    as={Link}
                    to={props.path}
                    eventKey={props.menu}
                    bsPrefix={`nav-list-item ${props.menuType}`}
                >
                    <ReactSVG className="sidebar-icon menu" src={props.icon}></ReactSVG>
                    <span className="menu-name">{props.menu}</span>
                </Nav.Link>
            </Nav.Item>
        );

        return props.sidebar === "closed" ? (
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip className="custom-tooltip">{props.menu}</Tooltip>}
            >
               <div className="table-display-value">
                                      {navItem}
                                    </div>
            </OverlayTrigger>
        ) : navItem;
    })()
)}

        </>
    );
}
